import { ReceiptText } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import AppShell from '@/components/AppShell';
import { Card, CardContent } from '@/components/ui/card';

export default function Invoicing() {
  const { user } = useAuth();

  return (
    <AppShell
      title="Invoicing"
      description="Create and manage customer invoices from GreenQuote."
      userLabel={user?.user_metadata?.full_name || user?.email}
    >
      <Card className="border-slate-200 shadow-sm">
        <CardContent className="flex min-h-80 flex-col items-center justify-center px-6 py-14 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-md bg-amber-50 text-amber-700">
            <ReceiptText className="h-7 w-7" />
          </div>
          <p className="mt-5 text-2xl font-semibold text-slate-950">Coming soon</p>
          <p className="mt-2 max-w-md text-sm text-slate-500">
            Invoicing is planned for GreenQuote so you can turn completed service work into customer invoices from the same workspace.
          </p>
        </CardContent>
      </Card>
    </AppShell>
  );
}
